var $ = require('jquery');
window.jQuery = $;
window.$ = $;